// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/aa390445e210cfd33ed8.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"37bf547fa3d9d5834ad2","152":"6cb7fa8142ce0a98489f","153":"edfa621422005aea491f"}[chunkId] + ".chunk.js";
};